<template lang="pug">
#pills-statement.tab-pane.fade.show.active(role='tabpanel' aria-labelledby='pills-statement-tab')
  .d-lg-none
    template(v-if="!startRender")
      template(v-if="statementList.length > 0")
        .transaction-single.pb-2.mb-3(v-for="statement in statementList")
          .mb-1.text-smaller {{ $moment(statement.working_date).format("YYYY-MM-DD") }}
          .d-flex.bg-row.rounded-pill.mb-1
            .flex-grow-1.text-primary {{$t('ui.settlement')}}
            .statement-type
              a.text-primary(v-if="$store.state.user.account.system_type === 'CASH'" :class="getColor(statement.transfer_amount)" href='javascript:void(0)' @click="checkSettlement(statement.working_date)") {{statement.transfer_amount}}
                i.fas.fa-chevron-circle-right.ml-1
              a.text-primary(v-else :class="getColor(statement.settled_amount)" href='javascript:void(0)' @click="checkSettlement(statement.working_date)") {{statement.settled_amount}}
                i.fas.fa-chevron-circle-right.ml-1
          .d-flex.bg-row.rounded-pill.mb-1
            .flex-grow-1.text-success.font-weight-bold.text-uppercase(:class="getColor(statement.winlose)" ) {{ $t(getText(statement.winlose)) }}
            .statement-type
              a.font-weight-normal(:class="getColor(statement.winlose)" href='javascript:void(0)' @click="getPlatformWinLose(statement.working_date)") {{statement.winlose}}
                i.fas.fa-chevron-circle-right.ml-1
          .d-flex.bg-row.rounded-pill.mb-1
            .flex-grow-1.text-info {{$t('ui.turnover')}}
            .statement-type.font-weight-normal
              a.text-info(href='#' data-dismiss='modal' data-toggle='modal' data-target='#modal-promo-statement') {{statement.turnover}}
                i.fas.fa-chevron-circle-right.ml-1.invisible
          .d-flex.bg-row.rounded-pill.mb-1
            .flex-grow-1.text-info {{$t('ui.turnover_valid')}}
            .statement-type.font-weight-normal
              a.text-info(href='#' data-dismiss='modal' data-toggle='modal' data-target='#modal-promo-statement') {{statement.valid_turnover}}
                i.fas.fa-chevron-circle-right.ml-1.invisible
          .d-flex.bg-row.rounded-pill.mb-1
            .flex-grow-1.text-info {{$t('ui.commission')}}
            .statement-type.font-weight-normal
              a.text-info(href='#' data-dismiss='modal' data-toggle='modal' data-target='#modal-promo-statement') {{statement.comm}}
                i.fas.fa-chevron-circle-right.ml-1.invisible
          .d-flex.bg-row02
            .flex-grow-1 {{$t('ui.account_opening')}}
            .font-weight-bold {{statement.account_opening}}
              i.fas.fa-chevron-circle-right.ml-1.invisible
          .d-flex.bg-row02
            .flex-grow-1 {{$t('ui.account_closing')}}
            .font-weight-bold {{statement.account_closing}}
              i.fas.fa-chevron-circle-right.ml-1.invisible
          .d-flex.bg-row02
            .flex-grow-1 {{$t('ui.account_balance')}}
            .font-weight-bold {{statement.account_balance}}
              i.fas.fa-chevron-circle-right.ml-1.invisible
          //- .d-flex.bg-row02
            .flex-grow-1 {{$t('ui.cash_opening')}}
            .font-weight-bold {{statement.cash_opening}}
              i.fas.fa-chevron-circle-right.ml-1.invisible
          //- .d-flex.bg-row02
            .flex-grow-1 {{$t('ui.cash_closing')}}
            .font-weight-bold {{statement.cash_closing}}
              i.fas.fa-chevron-circle-right.ml-1.invisible
          //- .d-flex.bg-row02
            .flex-grow-1 {{$t('ui.cash_balance')}}
            .font-weight-bold {{statement.cash_balance}}
              i.fas.fa-chevron-circle-right.ml-1.invisible
      template(v-else)
        .text-center.my-2 {{ $t('ui.no_record') }}
    template(v-else)
      .text-center.my-2
        i.fas.fa-sync.fa-spin(style="color:white;")
  .d-none.d-lg-block
    .package-table.mb-0
      .row.table-row
        .col-2 {{$t('ui.date')}}
        .col {{$t('ui.settlement')}}
        .col {{$t('ui.winlose')}}
        .col {{$t('ui.turnover')}}
        .col {{$t('ui.turnover_valid')}}
        .col {{$t('ui.commission')}}
        .col {{$t('ui.account_opening')}}
        .col {{$t('ui.account_closing')}}
        .col {{$t('ui.account_balance')}}
        //- .col {{$t('ui.cash_opening')}}
        //- .col {{$t('ui.cash_closing')}}
        //- .col {{$t('ui.cash_balance')}}
      template(v-if="!startRender")
        template(v-if="statementList.length > 0")
          .row.table-row(v-for="statement in statementList")
            .col-2 {{ $moment(statement.working_date).format("YYYY-MM-DD") }}
            .col
              .statement-type
                a(v-if="$store.state.user.account.system_type === 'CASH'" :class="getColor(statement.transfer_amount)" href="javascript:void(0);" @click="checkSettlement(statement.working_date)") {{statement.transfer_amount}}
                  i.fas.fa-chevron-circle-right.ml-1
                a(v-else :class="getColor(statement.settled_amount)" href="javascript:void(0);" @click="checkSettlement(statement.working_date)") {{statement.settled_amount}}
                  i.fas.fa-chevron-circle-right.ml-1
            .col
              .statement-type
                a(:class="getColor(statement.winlose)" href="javascript:void(0);" @click="getPlatformWinLose(statement.working_date)") {{statement.winlose}}
                  i.fas.fa-chevron-circle-right.ml-1
            .col
              .statement-type
                a.font-weight-bold.text-primary(href='#' data-dismiss='modal' data-toggle='modal' data-target='#modal-transfer-detail') {{statement.turnover}}
            .col
              .statement-type
                a.font-weight-bold.text-info(href='#' data-dismiss='modal' data-toggle='modal' data-target='#modal-promo-statement') {{statement.valid_turnover}}
            .col {{statement.comm}}
            .col {{statement.account_opening}}
            .col {{statement.account_closing}}
            .col {{statement.account_balance}}
            //- .col {{statement.cash_opening}}
            //- .col {{statement.cash_closing}}
            //- .col {{statement.cash_balance}}
        template(v-else)
          .text-center.my-2 {{ $t('ui.no_record') }}
      template(v-else)
        .text-center.my-2
          i.fas.fa-sync.fa-spin
</template>
<script>
export default {
  components:{
  },
  data() {
    return {
      statementList: [],
      feedback: {
        success: "",
        status: ""
      },
      showDetails: false,
      category: "",
      loading: false,
      startRender: false,
    };
  },
  computed: {
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
  },
  mounted(){
    this.getMemberStatement()
  },
  methods:{
    checkSettlement(date){
      let final = this.$moment(date).format("YYYY-MM-DD") 
      this.$store.dispatch("user/settlementDate", final)
      $('#modal-transfer-detail').modal('show')
    },
    getPlatformWinLose(date){
      let final = this.$moment(date).format("YYYY-MM-DD")
      this.$store.dispatch("user/settlementDate", final)
      this.$emit("showBet", 2)
    },
    getColor(value) {
      if (value > 0) {
        return "text-success";
      } else if (value < 0) {
        return "text-danger";
      } else {
        return "no-deco";
      }
    },
    getText(value) {
      if (value > 0) {
        return "ui.win";
      } else if (value < 0) {
        return "ui.lose";
      } else {
        return "ui.tie";
      }
    },
    getMemberStatement() {
      if (this.sessionToken) {
        this.startRender = true
        let member_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getMemberStatement", { member_id, auth_token })
          .then(response => {
            if (response.success == true) {
              this.statementList = response.data
              this.startRender = false
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            this.startRender = false
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          })
      }
    },
    reset(){
      this.showDetails = false
    }
  }
}
</script>
<style lang="scss" scoped>
.table-statement-col{
  // white-space: nowrap;
  line-height: 1;
  text-align: center;
}
.custom-adjust{
  text-transform: inherit;
}
.no-deco{
  text-decoration: none !important;
  color: #fff !important;
}
</style>